import { quotationItemApi } from "../../api";

const QuotationItemService = {

    /**
     * ➕ Agregar item
     * POST /api/quotations/{quotationId}/items
     */
    addItem: async (
        quotationId: number,
        data: any
    ) => {

        const response =
            await quotationItemApi.addCustom(
                `/${quotationId}/items`,
                data
            );

        return response.data;

    },

    /**
     * ✏️ Actualizar item
     * PUT /api/quotations/{quotationId}/items/{itemId}
     */
    updateItem: async (
        quotationId: number,
        itemId: number,
        data: any
    ) => {

        const response =
            await quotationItemApi.modifyCustom(
                `/${quotationId}/items/${itemId}`,
                data
            );

        return response.data;

    },

    /**
     * ❌ Eliminar item
     * DELETE /api/quotations/{quotationId}/items/{itemId}
     */
    deleteItem: async (
        quotationId: number,
        itemId: number
    ) => {

        const response =
            await quotationItemApi.removeCustom(
                `/${quotationId}/items/${itemId}`
            );

        return response.data;

    },

};

export default QuotationItemService;